module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "color": _vm.color
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('span', {
    staticClass: "pa-3 mt-3",
    staticStyle: {
      "font-size": "16px",
      "font-weight": "400"
    }
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('v-btn-toggle', {
    staticClass: "btn-filter-group pa-3",
    attrs: {
      "small": "",
      "dense": "",
      "mandatory": "",
      "color": "info"
    },
    model: {
      value: (_vm.toggle_filter),
      callback: function($$v) {
        _vm.toggle_filter = $$v
      },
      expression: "toggle_filter"
    }
  }, [_c('v-btn', {
    staticClass: "btn-period",
    on: {
      "click": _vm.monthlyClick
    }
  }, [_vm._v("\n                Monthly\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-period",
    on: {
      "click": _vm.quartelyClick
    }
  }, [_vm._v("\n                Quartely\n              ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-period",
    on: {
      "click": _vm.yearlyClick
    }
  }, [_vm._v("\n                Yearly\n              ")])], 1), _vm._v(" "), _c('v-autocomplete', {
    staticClass: "col-md-3 col-sm-12 col-xs-12 pa-3",
    attrs: {
      "item-value": "id",
      "item-text": "name",
      "items": _vm.firstFilters,
      "label": _vm.firstFilterLabel,
      "hide-details": "",
      "outlined": "",
      "auto-select-first": ""
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: (_vm.selectedFilter.firstFilterId),
      callback: function($$v) {
        _vm.$set(_vm.selectedFilter, "firstFilterId", $$v)
      },
      expression: "selectedFilter.firstFilterId"
    }
  }), _vm._v(" "), (_vm.summary && _vm.summary.length) ? _c('v-card', {
    staticClass: "summary-card",
    attrs: {
      "max-width": "330",
      "height": "180",
      "outlined": ""
    }
  }, [_c('v-card-text', [_c('p', {
    staticClass: "text-h6 text--primary"
  }, [_vm._v("\n                  " + _vm._s(_vm.summaryTitle) + "\n                ")]), _vm._v(" "), _vm._l((_vm.summary), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "text--primary",
      staticStyle: {
        "font-size": "14px",
        "margin": "5px"
      }
    }, [_vm._v("\n                  " + _vm._s(item.label) + ": "), _c('strong', [_vm._v(_vm._s(_vm._f("thousandSeprator")(item.data)))])])
  })], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('canvas', {
    attrs: {
      "id": _vm.id,
      "width": "500",
      "height": "200"
    }
  })])], 1), _vm._v(" "), (_vm.detail) ? _c('v-row', {
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    },
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "align": "end",
      "sm": "12",
      "md": "9",
      "lg": "9"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.detailClick
    }
  }, [_vm._v("Details")])], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72c433ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/DashboardComponents/Chart/Bar.vue
// module id = 2192
// module chunks = 0